const MainContainer = ({ noTopPadding, children }) => {
  return (
    <div
      className={`max-w-7xl m-auto px-4 ${
        noTopPadding ? "pt-4 pb-4" : "py-8 sm:py-10"
      }`}
    >
      {children}
    </div>
  );
};

export default MainContainer;
